import React from "react";
import "./plans.css";
import { Link } from "react-router-dom";

const Plans = () => {
  return (
    <>
      <section className="section   pb-5" id="pricing-plans">
          <img
          src="assetsfront/images/pkg.jpg"
          alt="student registration"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        />

        <h1 className="title text-center  mt-4 " style={{ fontWeight: "600" }}>
          Our <strong style={{ color: "#f7b205" }}> Pricing Plans</strong>
        </h1>
        <div className="top" />
        <div className="container">
          {/* ***** Section Title Start ***** */}
          <div className="row">
            
            <div className="offset-lg-3 col-lg-6">
              <div className="center-text">
                
              </div>
            </div>
          </div>
          {/* ***** Section Title End ***** */}
          <div className="row">
            {/* ***** Pricing Item Start ***** */}
            <div className="col-lg-3 col-md-6">
              <div className="pricing-item">
                <div className="pricing-header">
                  <h3 className="pricing-title">TRIAL PLAN</h3>
                </div>
                <div className="pricing-body">
                  <div className="price-wrapper">
                     <span className="price" style={{color:"green"}}>FREE</span>
                   </div>
                  <ul className="list">
                    <li className="active"><i style={{color:"green"}} class="fa fa-check-circle" aria-hidden="true"></i>  Join Free Batch</li>
                    <li className="active"><i style={{color:"green"}} class="fa fa-check-circle" aria-hidden="true"></i>  Free Recorded 100 Hours Watch Any Videos</li>
                    <li className="active"><i style={{color:"green"}} class="fa fa-check-circle" aria-hidden="true"></i>  Free Notes or Books</li>
                  
                    <li className="active"><i style={{color:"green"}} class="fa fa-check-circle" aria-hidden="true"></i> 24x7 Great Support</li>
                   </ul>

                   <div className="price-wrapper"  style={{backgroundColor:"green"}}>
                    <span className="currency" style={{color:"white"}}>₹ </span>
                    <span className="price" style={{color:"white"}}>0.00</span>
                    <span className="period" style={{color:"white"}}>/Month</span>
                  </div> 
                </div>
                <div className="pricing-footer">
                 <Link to='../studentlogin' className="btn-primary-line">
                    Select Plan 
                  </Link>                
                  </div>

                
              </div>
            </div>
            {/* ***** Pricing Item Start ***** */}
            <div className="col-lg-3 col-md-6">
              <div className="pricing-item">
                <div className="pricing-header">
                  <h3 className="pricing-title">BASIC PLAN</h3>
                </div>
                <div className="pricing-body">
                  {/* <div className="price-wrapper">
                    <span className="currency">$</span>
                    <span className="price">10.90</span>
                    <span className="period">/Month</span>
                  </div> */}
                  <div className="price-wrapper">
                     <span className="price" style={{color:"#007bff"}}>RECORDED BATCH </span>
                   </div>

                  <ul className="list">
                    <li className="active"><i style={{color:"rgb(0, 123, 255)"}} class="fa fa-check-circle" aria-hidden="true"></i> 1 Year Validity</li>
                    <li className="active"><i style={{color:"rgb(0, 123, 255)"}} class="fa fa-check-circle" aria-hidden="true"></i> Complete GS Package</li>
                    <li className="active"><i style={{color:"rgb(0, 123, 255)"}} class="fa fa-check-circle" aria-hidden="true"></i> Pre+ Mains+ CSAT</li>
                    <li className="active"><i style={{color:"rgb(0, 123, 255)"}} class="fa fa-check-circle" aria-hidden="true"></i> Online Current Affair Pdf</li>
                    <li>24x7 Great Support</li>
                   </ul>
                   
                   <div className="price-wrapper"  style={{backgroundColor:"#f0f0f0"}}>
                      <span className="price" style={{color:"red"}}><del>12000</del> </span>
                    <span className="currency" style={{color:"black"}}>₹ </span>
                    <span className="price" style={{color:"black"}}>9999</span>
                    <span className="period" style={{color:"black"}}>/Year</span>
                  </div>
                </div>
                <div className="pricing-footer">
                  <Link to='../our-batches' className="btn-primary-line">
                    Select Plan 
                  </Link>
                </div>
              </div>
            </div>
            {/* ***** Pricing Item End ***** */}
            {/* ***** Pricing Item Start ***** */}
            <div className="col-lg-3 col-md-6">
              <div className="pricing-item active">
                <div className="pricing-header">
                  <h3 className="pricing-title">COMPLETE PLAN</h3>
                </div>
                <div className="pricing-body">
                   <div className="price-wrapper">
                     <span className="price" style={{color:"#f7b205",fontSize: "21px"}}>Live + Recorded Batch </span>
                   </div>
                  <ul className="list">
                    <li className="active"><i style={{color:"#f7b205"}} class="fa fa-check-circle" aria-hidden="true"></i>   GS,Pre & Mains (CSAT).</li>
                    <li className="active"><i style={{color:"#f7b205"}} class="fa fa-check-circle" aria-hidden="true"></i> Current Affairs Class</li>
                    <li className="active"><i style={{color:"#f7b205"}} class="fa fa-check-circle" aria-hidden="true"></i> Unlimited Access Recording </li>
                    <li className="active"><i style={{color:"#f7b205"}} class="fa fa-check-circle" aria-hidden="true"></i> NCERT Based Class & PDF</li>
                     <li className="active"><i style={{color:"#f7b205"}} class="fa fa-check-circle" aria-hidden="true"></i> 40+Papers Including Gs+CSAT</li>
                    </ul>


                    <div className="price-wrapper"  style={{backgroundColor:"#f0f0f0"}}>
                      <span className="price" style={{color:"red"}}><del>65000</del> </span>
                    <span className="currency" style={{color:"black"}}>₹ </span>
                    <span className="price" style={{color:"black"}}>45000</span>
                    <span className="period" style={{color:"black"}}>/Year</span>
                  </div>
                </div>
                <div className="pricing-footer">
                 <Link to='../our-batches' className="btn-primary-line">
                    Select Plan 
                  </Link>
                </div>
              </div>
            </div>
            {/* ***** Pricing Item End ***** */}
            {/* ***** Pricing Item Start ***** */}
            <div className="col-lg-3 col-md-6">
              <div className="pricing-item">
                <div className="pricing-header">
                  <h3 className="pricing-title">COMPLETE PLAN</h3>
                </div>
                <div className="pricing-body">
                <div className="price-wrapper" >
                     <span className="price" style={{color:"#022386",fontSize: "21px"}}>Other Batch - TGT/PGT/PRT/DSSSB .. </span>
                   </div>
                  <ul className="list">
                    <li className="active"><i style={{color:"#022386"}} class="fa fa-check-circle" aria-hidden="true"></i> 6 Months Validity </li>
                    <li className="active"><i style={{color:"#022386"}} class="fa fa-check-circle" aria-hidden="true"></i> Complete Paper-I & Paper-II</li>
                    <li className="active"><i style={{color:"#022386"}} class="fa fa-check-circle" aria-hidden="true"></i> All Notes And Books</li>
                    <li className="active"><i style={{color:"#022386"}} class="fa fa-check-circle" aria-hidden="true"></i> Mock Test</li>
                    <li className="active"><i style={{color:"#022386"}} class="fa fa-check-circle" aria-hidden="true"></i> Paper-I=<b>19600</b>,Paper-II=<b>19600</b></li>
 
                  </ul>

                    <div className="price-wrapper"  style={{backgroundColor:"#f0f0f0"}}>
                      <span className="price" style={{color:"red"}}><del>39200</del> </span>
                    <span className="currency" style={{color:"black"}}>₹ </span>
                    <span className="price" style={{color:"black"}}>33200</span>
                    <span className="period" style={{color:"black"}}>/Year</span>
                  </div>
                </div>
                <div className="pricing-footer">
                  <Link to='../our-batches' className="btn-primary-line">
                    Select Plan 
                  </Link>
                </div>
              </div>
            </div>
            {/* ***** Pricing Item End ***** */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Plans;
